import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import "../App.css"

// components
import GlobalHeaader from '../components/GlobalHeader';
import GlobalFooter from '../components/GlobalFooter';
import BreadcrumbTrail from '../components/BreadcurmbTrail';
import Menu from '../components/Menu';
import ReportProblem from '../components/ReportProblem';

import { getElements } from "../api/blawksAPI";

export default function Provinces() {
  const { t } = useTranslation('translation');
  const [provinceList, setProvinceList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const kumuElements = require('../api/kumu_elements.json');

  useEffect(() => {
    // getElements('CSmith109', 'map-tool-21').then(res => {
    //   const ptResources = res.rows.filter(
    //     (elm) => elm.value.attributes['element type'] === 'PT Resources'
    //   );
    //   setProvinceList(ptResources);
    //   setIsLoading(false);
    // });
    setProvinceList(kumuElements.rows.filter(
        (elm) => elm.value.attributes['element type'] === 'PT Resources'
    ))
    setIsLoading(false);
  }, []);

  const getData = (data) =>
    data !== undefined && data !== "" ? parse(data) : "Not available";

  // Sort alphabetically by label (province/territory name)
  const sortedProvinces = provinceList.sort((a, b) =>
    a.value.attributes.label.localeCompare(b.value.attributes.label)
  );

  const provinceDropdowns = sortedProvinces.map((prov, index) => (
    <div key={index} className="mb-3">
      <details>
        <summary className="fw-bold">
          {getData(prov.value.attributes.label)}
        </summary>
        <div className="mt-2">
          {getData(prov.value.attributes.description)}
        </div>
      </details>
    </div>
  ));

  return (
    <div>
      <header>
        <GlobalHeaader />
        <Menu />
        <BreadcrumbTrail />
      </header>

      <main
        property="mainContentOfPage"
        className="page-content container"
        typeof="WebPageElement"
      >
        <h1 property="name" id="wb-cont">
          {t('Provinces and Territories of Canada')}
        </h1>

        {isLoading ? <p>Loading...</p> : provinceDropdowns}
      </main>

      <ReportProblem />
      <GlobalFooter />
    </div>
  );
}